import React from 'react';
import {KeyTermsTextInput} from './KeyTermsTextInput';

export const KeyTermsWithInfoTextInput = () => {
  return <KeyTermsTextInput infoText="For multiple keywords use a semicolon." />;
};
